module.exports = __webpack_public_path__ + "static/media/check-orange.2eeab2df.svg";